import { render } from "./MobileTodoDetailPage.vue?vue&type=template&id=03160b63&scoped=true"
import script from "./MobileTodoDetailPage.vue?vue&type=script&lang=js"
export * from "./MobileTodoDetailPage.vue?vue&type=script&lang=js"

import "./MobileTodoDetailPage.vue?vue&type=style&index=0&id=03160b63&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03160b63"]])

export default __exports__